import React from 'react'
import ProjectLayout from '../../../../../layout/components/ProjectLayout'
import ProjectNotes from '../components/ProjectNotes'
import { useParams } from 'react-router-dom'
import ActivityTimeline from '../components/activity/ActivityTimeline';
import ProjectTeam from '../components/ProjectTeam';
import ProjectTaskList from '../components/ProjectTaskList';

function ProjectTeamListPage() {
    const {id} = useParams();
    return (
        <ProjectLayout>
            <div className='row'>
                <div className='col-md-9 border'>
                    <ProjectTeam projectId={id} autoload={true} />
                </div>
                <div className='col-md-3'>
                    <ProjectNotes projectId={id} autoload={true}/>
                </div>
            </div>
        </ProjectLayout>
    )
}

export default ProjectTeamListPage